import React from 'react';

const HeightIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="63.391" height="27.849" viewBox="0 0 63.391 27.849"><g opacity=".5" stroke="#fff" strokeWidth="1.4" fill="none"><path d="M38.916 24.7l-31.039-.553v-14.813l12.171-8.576 18.23 4.557 24.414 3.714v12.318zM38.963 5.69l-.443 19.066-10.187-.207.139-10.273h-9.543v9.986"/></g><path d="M2.507 4.049l-.01 21.32" stroke="#d59300" strokeWidth="2" fill="none"/><path d="M5.201 4.494l-5 .085 2.037-3.271zM5.041 24.62l-5-.09 2.034 3.273z" fill="#d59300"/></svg>
  )
}
export default HeightIcon;